/**
 * Ключи согласия на куки — общие для хука (клиент) и встроенного скрипта в
 * <head> (сервер). Отдельный модуль без React, чтобы серверный root-shell не
 * тянул клиентский код.
 */
export const COOKIE_CONSENT_KEY = "cookie-consent";
export const COOKIE_PREFERENCES_KEY = "cookie-preferences";
export const COOKIE_CONSENT_VERSION_KEY = "cookie-consent-version";

/**
 * Версия текста согласия (KAN-1198). До неё баннер был информационным: одна
 * кнопка «Понятно», и у всех, кто её нажал, сохранено `analytics: false`.
 * С появлением Метрики вопрос стал другим — старый ответ на него не
 * отвечает, поэтому при смене версии баннер показывается заново.
 */
export const COOKIE_CONSENT_VERSION = "2";

/** Атрибут <html>: пользователь уже ответил на текущую версию — баннер скрыт CSS. */
export const CONSENT_ANSWERED_ATTR = "data-consent-answered";

/**
 * KAN-1244: баннер теперь в SSR-HTML (раньше dynamic ssr:false рисовал его после
 * гидратации, и на главной он становился LCP-элементом: 735 → ~1780 мс).
 * Чтобы ответившие не видели его ни кадра, этот скрипт до первой отрисовки
 * помечает <html>, а CSS прячет баннер по атрибуту.
 */
export const CONSENT_ANSWERED_SCRIPT =
  `try{if(localStorage.getItem(${JSON.stringify(COOKIE_CONSENT_KEY)})` +
  `&&localStorage.getItem(${JSON.stringify(COOKIE_CONSENT_VERSION_KEY)})===${JSON.stringify(COOKIE_CONSENT_VERSION)})` +
  `document.documentElement.setAttribute(${JSON.stringify(CONSENT_ANSWERED_ATTR)},"")}catch(e){}`;
